const iapCacheKey = "iapCacheData";
const iapCacheTimeStampKey = "iapCacheTS";
const iapCacheLifetimeDays = 3;

export const cacheOfferingsResponse = (flutterData) => {
    try {
        localStorage.setItem(iapCacheKey, JSON.stringify(flutterData));
        localStorage.setItem(iapCacheTimeStampKey, Date.now());

        window.flutterEventLog.unshift({
            eventName: 'cacheOfferingsResponse',
            data: {},
        });

    } catch(error) {
        window.captureException(error);
    }
}

export const getCachedOfferingsResponse = () => {
    try {
        if (!isValidCache(iapCacheLifetimeDays)) return null;
        else return JSON.parse(localStorage.getItem(iapCacheKey));
    } catch(error) {
        window.captureException(error);
        return null;
    }
}

export const isValidCache = (lifetime = 1) => {
    try {
        const cachedData = localStorage.getItem(iapCacheKey);
        const timestamp = localStorage.getItem(iapCacheTimeStampKey);
        return (cachedData && typeof JSON.parse(cachedData) === "object" && timestamp && parseInt(timestamp) > Date.now() - (lifetime * 24 * 60 * 60 * 1000));
    } catch(error) {
        window.captureException(error);
        return false;
    }
}
